// 统一加前缀tw

// 性别设置：all men women kids 页面初始化之后进行初始化，每次修改性别时同步至storage
const TW_GENDER_KEY = "gender";

function twGetData(key) {
  const res = localStorage.getItem(key);
  return res || "";
}

function twSetData(key, value) {
  localStorage.setItem(key, value);
}
